module.exports = __webpack_public_path__ + "static/media/wedge-antilles.27a281a1.jpg";